import type { DirtyFile } from "./store";

export interface FileWriter {
  write(filename: string, content: string): Promise<void>;
}

export interface SaveResult {
  saved: string[];
  rolledBack: string[];
}

export async function writeFilesWithRollback(files: DirtyFile[], writer: FileWriter): Promise<SaveResult> {
  const saved: DirtyFile[] = [];
  try {
    for (const file of files) {
      await writer.write(file.filename, file.content);
      saved.push(file);
    }
    return { saved: saved.map((file) => file.filename), rolledBack: [] };
  } catch (error) {
    const rolledBack: string[] = [];
    for (const file of [...saved].reverse()) {
      try {
        await writer.write(file.filename, file.originalContent);
        rolledBack.push(file.filename);
      } catch {
        // Keep attempting the remaining rollback writes. The caller reports the exact result.
      }
    }
    const detail = error instanceof Error ? error.message : String(error);
    const failure = new Error(
      `Save failed after writing ${saved.length} file(s). Rolled back: ${rolledBack.join(", ") || "none"}. ${detail}`,
    );
    Object.assign(failure, { saved: saved.map((file) => file.filename), rolledBack });
    throw failure;
  }
}
